import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class IsAuthenticatedGuard {
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private auth: AuthService,
        private router: Router
    ) {}

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        if (isPlatformBrowser(this.platformId)) {
            const doesSessionExist = await this.auth.checkForSession();
            if (!doesSessionExist) {
                return this.router.navigate(['/auth'], {
                    queryParams: { redirectToPath: state.url },
                });
            }

            return doesSessionExist;
        }

        return false;
    }
}
